import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
} from "@/comn/hooks";
import {
    COMN_BASE,
    COMN_URLS,
    COMN_APIS,
    SG_APP_DTL_PAY_INFO_LIST,
} from "@/tz/go/egaz/osci/lpco/comn/services/OsciLpcoComnAppService";
import { APP_DTL_BILL_INFO } from "./APP_DTL_BILL_INFO";

export const APP_DTL_PAY_INFO = (props: any) => {
    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    const param = { ...props.state };

    /*
     * Application Payment Info List Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Application Payment Info List !== 신청서 수수료 목록 ==!
        appFeeList: useGrid({
            defaultSchema: SG_APP_DTL_PAY_INFO_LIST,
            // page: pgeStore?.page,
            // size: pgeStore?.size,
        }),
    };

    /*
     * Application Item Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getAppFeeList: useFetch({
            api: () => {
                return COMN_APIS.getAppFeeList({ ...props.state });
            },
            onSuccess: (data) => {},
            onError: (error) => {
                const errmsg = error.response.data.errorCode == -1 ? "msg.osc.00015" : error.response.data.errorMessage;

                modal.openModal({
                    content: errmsg,
                });
            },
            showToast: false,
        }),
    };

    /*
     * Application Item Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        setInit: () => {
            fetch.getAppFeeList.fetch();
        },
    };

    useEffect(() => {
        handler.setInit();
    }, []);

    const render = {
        grid_payInfoLst: {
            head: {},
            cell: {
                bllNo: (props: any) => {
                    const { binding, rowValues, value } = props;
                    // Bill not issued yet, no popup to open !== 고지서 미발급이라 열 팝업이 없다 ==!
                    if (!rowValues.bllNo) {
                        return <></>;
                    }
                    return (
                        <Layout direction="col" gap={1}>
                            <Link
                                to={``}
                                state={param}
                                onClick={() => {
                                    param.feeId = rowValues.feeId;
                                    modal.openModal({
                                        // url 로 팝업창의 주소를 기입
                                        // url: COMN_URLS.esweBllInfoPpup,
                                        content: <APP_DTL_BILL_INFO state={param} />,
                                        // 팝업창에 보낼 파라메터 정의
                                        // params: { feeId: rowValues.feeId },
                                        size: "lg",
                                        draggable: true,
                                        // 팝업창에서 modal.postMessage 메소드 실행시 callback 함수
                                        callback: (data) => {
                                            if (data != null && data != "") {
                                                modal.closeModal();
                                            }
                                        },
                                    });
                                }}
                            >{`${rowValues.bllNo}`}</Link>
                        </Layout>
                    );
                },
            },
            edit: {},
            checkbox: (row: any) => {
                // row : 해당 row 의 데이터(rowValues)
                // return 값이 true 이면 checkbox enabled (선택가능);
                // return 값이 false 이면 checkbox disabled (선택불가능);
                // return row.sttsCd === "DR"; // row 데이터에 의한 제어 : row  데이터의 mrn 값이 12345 이면 checkbox enabled(선택가능)
            },
        },
    };

    return (
        <Page>
            {/* <form> */}
            <Group>
                <Group.Body>
                    <Layout direction="col">
                        <Layout>
                            <Layout.Left>
                                <Group.Title title={"T_PAY_FEE_DTL"} titleSize={1}></Group.Title>
                            </Layout.Left>
                        </Layout>

                        <Group>
                            <Group.Body>
                                <Grid
                                    {...grid.appFeeList.grid}
                                    data={fetch.getAppFeeList.data?.feeList}
                                    render={render.grid_payInfoLst}
                                />
                            </Group.Body>
                        </Group>
                    </Layout>
                </Group.Body>
            </Group>
        </Page>
    );
};
